import axiosInstance from "../../apiAxios/axiosInstance";

export const BusinessList = async (payload) => {
  const response = await axiosInstance.post("/admin/business-list", payload);
  return response.data;
};

export const ActiveBusinessList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-business-list",payload);
   return resposne.data
};

export const AddBusiness = async (payload) => {
  const response = await axiosInstance.post("/admin/business-store", payload);
  return response.data;
};

export const ViewBusiness = async (payload) => {
  const response = await axiosInstance.post("/admin/business-show", payload);
  return response.data;
};

export const UpdateBusiness = async (payload) => {
  const response = await axiosInstance.post("/admin/business-update", payload);
  return response.data;
};

export const DeleteBusiness = async (payload) => {
  const response = await axiosInstance.post("/admin/business-delete", payload);
  return response.data;
};

export const BusinessChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/business-status-update",
    payload
  );
  return response.data;
};
